import React, { useContext, useEffect, useRef, useState } from "react";
import styles from "./login.module.css";
import notification from "../../images/notifications.png";
import logo from "../../images/logo.png";
import { useDispatch, useSelector } from "react-redux";
import { authentication } from "../../redux/features/authenticationSlice/authenticationSlice";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import loading from "../../images/rect_loading.gif";

const Login = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [formValue, setFormValue] = useState({
    email: "",
    password: "",
  });
  const [error, setError] = useState("")
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const showRef = useRef(null);

  const showPassword = () => {
    let typeOfInput = showRef.current.type;
    if (typeOfInput === "password") {
      showRef.current.type = "text";
    } else {
      showRef.current.type = "password";
    }
  };

  const changeHandler = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    setFormValue({
      ...formValue,
      [name]: value,
    });
  };

  const submitHandler = async (e) => {

    
    console.log(process.env.REACT_APP_BASE_URL, "<===url")

    e.preventDefault();
    if(formValue.email == "" && formValue.password == ""){
      setError("Please fill the login details")
    } else if(formValue.email == ""){
      setError("Email cannot be empty")
    } else if(formValue.password == ""){
      setError("Password cannot be empty")
    } else {
      try {
        setIsLoading(true);
        const loginResult = {
          method: "post",
          url: `${process.env.REACT_APP_BASE_URL}/login`,
          withCredentials: true,
          headers: {
            "Content-Type": "application/json",
          },
          data: formValue,
        };
        const response = await axios(loginResult);
        // console.log("Response:", response);
        if (response.status == 200) {
        // console.log("Responseinside:", response);

          toast.success("Succefully logged in");
          dispatch(authentication(true));
          navigate("/");
        } else {
          toast.error("Something went wrong");
        }
      } catch (error) {
        // console.error("Error:", error);
        if (error?.response?.status == 401) {
          toast.error("Incorrect credentials");
        } else {
          toast.error("Something went wrong");
        }
        setIsLoading(false);
      } 
    }
  };

  useEffect(() => {
    dispatch(authentication(false));
  }, []);

  return (
    <div className={styles.container}>
      <div className={styles.left_section}>
        <img
          src={logo}
          alt="logo"
          className={styles.logo}
          width={200}
          height={40}
        />
        <img
          className={styles.left_image}
          src={notification}
          alt="notification"
          loading="lazy"
        />
      </div>
      <div className={styles.right_section}>
        <div className={styles.right_section_heading}>
          <h3>Welcome!</h3>
          <p>Get started with your account</p>
        </div>
        <form onSubmit={submitHandler} className={styles.signup_form}>
          <input
            type="email"
            name="email"
            placeholder="Email"
            onChange={changeHandler}
          ></input>
          <div className={styles.input_password}>
            <input
              ref={showRef}
              type="password"
              name="password"
              placeholder="Password"
              onChange={changeHandler}
            ></input>
            <div className={styles.show_password}>
              <input
                className={styles.show_checkbox}
                type="checkbox"
                onClick={showPassword}
              ></input>
              <p>Show Password</p>
            </div>
          </div>
          <div className={styles.button_section}>
            <p>{error}</p>
            {isLoading ? (
              <img src={loading} alt="loading" width={40} height={40} />
            ) : (              
              <button type="submit">Login</button>
            )}
          </div>
        </form>
        <ToastContainer position="top-center" />
      </div>
    </div>
  );
};

export default Login;
